export enum VerificationType {
  BusinessInstantId = 'business_instant_id',
  PhoneFinder = 'phone_finder',
}

export interface UserDocumentStatus {
  name: string;
  documentStatus: string;
}
